import axios from 'axios'
import {AuthModel, CustomDefaults} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const DESK_EMBED_KEY = 'bottomup-desk-embed'

export function rememberDeskEmbed(): boolean {
  const flagged = new URLSearchParams(window.location.search).get('embed') === '1'
  if (flagged) sessionStorage.setItem(DESK_EMBED_KEY, '1')
  return flagged || sessionStorage.getItem(DESK_EMBED_KEY) === '1'
}
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(token: string | undefined) {
  const customHeader = axios.defaults.headers as unknown as CustomDefaults

  customHeader.Accept = 'application/json'
  if (token) {
    customHeader.Authorization = token
  }
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
